import { render, staticRenderFns } from "./MEvaluationBibliographicResourceForm.vue?vue&type=template&id=e6ae68f4&scoped=true"
import script from "./MEvaluationBibliographicResourceForm.vue?vue&type=script&lang=js"
export * from "./MEvaluationBibliographicResourceForm.vue?vue&type=script&lang=js"
import style0 from "./MEvaluationBibliographicResourceForm.vue?vue&type=style&index=0&id=e6ae68f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ae68f4",
  null
  
)

export default component.exports